import { Link } from "@tiptap/extension-link";

const CustomLink = Link.extend({
    addAttributes() {
        return {
            // Keep Link's own attributes (href, target, rel) — without the
            // parent spread the schema loses href and every link renders dead
            // (#145463).
            ...this.parent?.(),
            linktype: {
                default: 'link',
                renderHTML: (attributes: any) => {
                    return {
                        'data-linktype': attributes.linktype,
                        class: `linktype-${attributes.linktype}`,
                    };
                },
            }
        };
    },
});


export default CustomLink;